export const logoSrc = 'https://a.storyblok.com/f/148087/x/653b424584/dtk-logo.svg';
export const smalllogoSrc = 'https://a.storyblok.com/f/148087/220x214/076c38a83c/dtk_logo_positiv_rgb.png';
